import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "services/axios";
import { connect } from "react-redux";
import Axios from "axios";
import { errorMessage } from "../../Utils";

import {
  Card,
  Button,
  Table,
  Input,
  Icon,
  message,
  Tooltip,
  Modal,
  Tag,
  Spin,
  Switch,
} from "antd";

import downloadExcel from "../../../services/downloadExcel";
import ModalUpload from "./Modal/ModalUpload";
import ModalDownload from "./Modal/ModalDownload";

const confirmDelete = Modal.confirm;

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userList: [],
      current: 1,
      searchKey: "nrp",
      searchText: "",
      limit: 100,
      page: 1,
      totalPage: 1,
      confirmLoading: false,
      disableButton: true,
      openModalUpload: false,
      fileList: null,
      openModalDownload: false,
      status: null,
      branch: null,
    };
    this.addFileList = this.addFileList.bind(this);
    this.downloadData = this.downloadData.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.visibleModalDownload = this.visibleModalDownload.bind(this);
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm({ closeDropdown: false });
    this.setState(
      { searchText: selectedKeys[0] || "", searchKey: dataIndex, page: 1 },
      () => this.fetchUser()
    );
  };

  handleReset = (clearFilters) => {
    // confirm({ closeDropdown: false });

    this.setState({ searchText: "", searchKey: "nrp", page: 1 }, () =>
      this.fetchUser()
    );
    clearFilters();
  };

  fetchUser() {
    this.setState({ isLoading: true });
    let { page, limit, searchKey, searchText } = this.state;
    let role = this.props.match.params.role;
    let query = `${role}?page=${page}&limit=${limit}&searchKey=${searchKey}&searchText=${searchText}`;
    axios
      .get(`/admin-panel/user/${query}`)
      .then((result) => {
        this.setState({
          userList: result.data.users,
          page: result.data.page,
          limit: result.data.limit,
          totalPage: result.data.totalPage,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({ isLoading: false });
        message.error("Failed fetch user list");
      });
  }

  componentDidMount() {
    this.fetchUser();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.role !== this.props.match.params.role) {
      this.setState(
        {
          isLoading: true,
          searchText: "",
          searchKey: "nrp",
          page: 1,
        },
        () => this.fetchUser()
      );
    }
  }

  deleteUser(id, email) {
    let self = this;
    let token = this.props.Auth.token;
    confirmDelete({
      title: `Anda yakin ingin menghapus user dengan email ${id}, ${email} ?`,
      content: "Jika Anda klik OK, maka user akan terhapus dari database",
      onOk() {
        self.setState({ isLoading: true });
        axios
          .delete(`user/${id}/`, {
            headers: {
              Authorization: token,
            },
          })
          .then((response) => {
            message.success("User berhasil dihapus");
            self.fetchUser();
          })
          .catch((err) => {
            self.setState({ isLoading: false });
            message.error("Gagal menghapus user");
          });
      },
      onCancel() {
        message.warning("Batal menghapus user");
      },
    });
  }

  activateUser(data) {
    if (data.role === "SALES_USER") {
      if (data.SalesProfile && data.SalesProfile.Branch) {
        this.doActivateUser(data.email);
      } else {
        Modal.warning({
          title: "Sales tidak terdaftar di cabang manapun",
          content:
            "Silahkan tambahkan cabang dan supervisor di Edit User. User akan otomatis aktif.",
        });
      }
    } else {
      this.doActivateUser(data.email);
    }
  }

  doActivateUser(email) {
    let self = this;
    let token = this.props.Auth.token;
    confirmDelete({
      title: `Anda yakin ingin mengaktifkan kembali user ini ${email} ?`,
      content: "Jika Anda klik OK, maka user akan aktif kembali",
      onOk() {
        self.setState({ isLoading: true });
        axios
          .post(
            `/user`,
            { email: email, status: "ACTIVE" },
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then((response) => {
            message.success("User berhasil diaktifkan");
            self.fetchUser();
          })
          .catch((err) => {
            message.error("Gagal mengaktifkan user");
          });
      },
      onCancel() {
        self.setState({ isLoading: false });
        message.warning("Batal mengaktifkan user");
      },
    });
  }

  handleTableChange(pagination, filters, sorter) {
    if (pagination.current != this.state.page) {
      if (pagination.current > this.state.page) {
        this.setState({ page: pagination.current || 1 }, () =>
          this.fetchUser()
        );
      } else {
        this.setState({ page: 1 }, () => this.fetchUser());
      }
    }
  }

  getRoleUser() {
    const role = this.props.match.params.role;
    let result = "other";
    if (role === "all") result = "all";
    else if (role === "sales") result = "Salesman";
    else if (role === "appraiser") result = "Appraiser";
    else if (role === "branch-head") result = "Branch Head";
    else if (role === "supervisor") result = "Supervisor";
    else if (role === "mobbi-supervisor") result = "Mobbi Supervisor";
    else if (role === "ali") result = "Acquisition Logistic & Inventory";
    else if (role === "pricing") result = "Pricing";
    else if (role === "boh") result = "BOH";
    else if (role === "tnt") result = "TNT";
    else if (role === "other") result = "Other";
    else if (role === "dispatcher") result = "Dispatcher";
    else if (role === "abm") result = "ABM";
    else if (role === "general-manager") result = "General Manager";
    return result;
  }

  tabUser(role) {
    let result;
    if (role === "APPRAISAL_USER") result = "appraiser";
    else if (role === "SALES_USER") result = "sales";
    else if (role === "BRANCH_HEAD_USER") result = "branch-head";
    else if (role === "SUPERVISOR") result = "supervisor";
    else if (role === "MOBBI_SUPERVISOR") result = "mobbi-supervisor";
    else if (role === "PRICING") result = "pricing";
    else if (role === "BOH") result = "boh";
    else if (role === "TNT") result = "tnt";
    else if (role === "DISPATCHER") result = "dispatcher";
    else if (role === "DIRECTORS_USER") result = "abm";
    else if (role === "GENERAL_MANAGER") result = "general-manager";
    else result = "other";
    return result;
  }

  // Get Item Download Excel by Role //
  getItemDownload(item, idx, role) {
    let result = {
      no: idx + 1,
      name: item.name,
      email: item.email,
      phone: item.phone,
      role: item.role,
      status: item.status,
    };

    if (role === "sales") {
      result = {
        no: idx + 1,
        nrp: item.nrp,
        email: item.email,
        name: item.name,
        phone: item.phone,
        branch: item.SalesProfile
          ? item.SalesProfile.SalesBranch
            ? item.SalesProfile.SalesBranch.branch
            : null
          : null,
        supervisor: item.SalesProfile
          ? item.SalesProfile.Supervisor
            ? item.SalesProfile.Supervisor.name
            : null
          : null,
        role: item.role,
        status: item.status,
        "No Whatsapp": item.SalesProfile ? item.SalesProfile.whatsapp : null,
        Bank: item.SalesProfile ? item.SalesProfile.bankName : null,
        "No Rekening": item.SalesProfile ? item.SalesProfile.bankAccNo : null,
        "Nama Pemilik Rekening": item.SalesProfile
          ? item.SalesProfile.bankBeneficiary
          : null,
        "No KTP": item.SalesProfile ? item.SalesProfile.noKTP : null,
        "No NPWP": item.SalesProfile ? item.SalesProfile.noNPWP : null,
      };
    } else if (role === "branch-head") {
      result = {
        no: idx + 1,
        nrp: item.BranchHead ? item.BranchHead.nrp : item.nrp,
        email: item.email,
        name: item.name,
        phone: item.phone,
        branch:
          item.BranchHead && Array.isArray(item.BranchHead.Branches)
            ? item.BranchHead.Branches.map((v) => v.branch).join(", ") || ""
            : null,
        role: item.role,
        status: item.status,
        Bank: item.BranchHead ? item.BranchHead.bankName : null,
        "No Rekening": item.BranchHead ? item.BranchHead.bankAccNo : null,
        "No KTP": item.BranchHead ? item.BranchHead.noKTP : null,
        "No NPWP": item.BranchHead ? item.BranchHead.noNPWP : null,
      };
    } else if (role === "boh") {
      result = {
        no: idx + 1,
        email: item.email,
        name: item.name,
        phone: item.phone,
        area:
          item.BOHProfile && item.BOHProfile.AreaBranch
            ? item.BOHProfile.AreaBranch.name
            : null,
        role: item.role,
        status: item.status,
      };
    } else if (role === "tnt") {
      result = {
        no: idx + 1,
        email: item.email,
        name: item.name,
        phone: item.phone,
        branch:
          item.TNTProfile && item.TNTProfile.SalesBranch
            ? item.TNTProfile.SalesBranch.branch
            : null,
        role: item.role,
        status: item.status,
      };
    } else if (role === "supervisor") {
      result = {
        no: idx + 1,
        nrp: item.User ? item.User.nrp : null,
        email: item.User.email,
        name: item.name,
        phone: item.User ? item.User.phone : null,
        branch: item.SalesBranch ? item.SalesBranch.branch : null,
        role: item.User ? item.User.role : null,
        status: item.User ? item.User.status : null,
        Bank: item.bankName || null,
        "No Rekening": item.bankAccNo || null,
        "No KTP": item.noKTP || null,
        "No NPWP": item.noNPWP || null,
      };
    } else if (role === "appraiser") {
      result["on / off appraisal"] = item.Appraiser
        ? item.Appraiser.isDisableAppraisal == true
          ? "off"
          : "on"
        : "on";
    }
    return result;
  }

  getQuery() {
    let result = "";
    let { branch, status } = this.state;
    if (branch) {
      result += `branch=${branch}&`;
    }

    if (status) {
      result += `status=${status}&`;
    }

    if (result == "") result = null;
    return result;
  }

  // Download Data User //
  async downloadData() {
    let query = this.getQuery();
    const role = this.props.match.params.role;
    this.setState({ confirmLoading: true });
    const data = await Axios.get(
      `${process.env.REACT_APP_API_URL}/admin-panel/user/download/${role}?${
        query ? query : null
      }`
    )
      .then((result) => {
        if (result.data.users && result.data.users.length > 0) {
          let getRole = this.getRoleUser();
          const users = result.data.users.map((item, idx) => {
            const getItem = this.getItemDownload(item, idx, role);
            return {
              ...getItem,
            };
          });
          downloadExcel(users, `Users - ${getRole}`);
          this.setState({ openModalDownload: false });
        } else {
          message.error("Tidak ada data");
        }

        this.setState({ confirmLoading: false });
      })
      .catch((err) => {
        errorMessage(err.response || err);
        this.setState({ confirmLoading: false });
      });
  }

  // Download Data Branch //
  async downloadBranch() {
    const data = await axios
      .get(`/misc/branches`)
      .then((result) => {
        if (result.data.branches && result.data.branches.length > 0) {
          const branches = result.data.branches.map((item, idx) => {
            return {
              no: idx + 1,
              branch: item.branch,
            };
          });
          downloadExcel(branches, `Branch List`);
        }
      })
      .catch((err) => {
        errorMessage(err.response || err);
      });
  }

  // Download Data Branch //
  async downloadArea() {
    const data = await axios
      .get(`/misc/area-branches`)
      .then((result) => {
        if (result.data.areaBranches && result.data.areaBranches.length > 0) {
          const areaBranches = result.data.areaBranches.map((item, idx) => {
            return {
              no: idx + 1,
              area: item.name,
            };
          });
          downloadExcel(areaBranches, `Branch List`);
        }
      })
      .catch((err) => {
        errorMessage(err.response || err);
      });
  }

  onChangeFilter(type, val) {
    if (type === "status") {
      this.setState({ status: val });
    } else if (type === "branch") {
      this.setState({ branch: val });
    }
  }

  // Get Branch Table //
  getBranch(row, role) {
    let result;
    if (role === "branch-head") {
      if (row && row.BranchHead && Array.isArray(row.BranchHead.Branches)) {
        result = row.BranchHead.Branches.map((v) => v.branch).join(", ");
      }
    } else if (role === "tnt") {
      if (
        row &&
        row.TNTProfile &&
        Array.isArray(row.TNTProfile.SalesBranches)
      ) {
        result = row.TNTProfile.SalesBranches.map((v) => v.branch).join(", ");
      }
    } else if (role === "sales") {
      if (row && row.SalesProfile && row.SalesProfile.SalesBranch) {
        result = row.SalesProfile.SalesBranch.branch || "";
      }
    } else if (role === "supervisor") {
      if (row && row.SalesBranch) {
        result = row.SalesBranch.branch || "";
      }
    } else if (role === "mobbi-supervisor") {
      if (row && row.Branches) {
        result = row.Branches.map((v) => v.branch).join(", ");
      }
    }
    return result;
  }

  // Get TNT Table //
  getTNT(row) {
    let result;
    if (row && Array.isArray(row.TNTUsers)) {
      result = row.TNTUsers.map((v) => v.User && v.User.name).join(", ");
    }

    return result;
  }

  // Get Obj Table by Role
  getObjRole(column) {
    let result;
    const role = this.props.match.params.role;
    const roleNRP = ["all", "sales", "branch-head", "supervisor"];

    if (column === "nrp") {
      if (roleNRP.includes(role)) {
        result = {
          key: "nrp",
          title: "NRP",
          dataIndex: "nrp",
          width: 200,
          ...this.getColumnSearchProps("nrp"),
          render: (text, row) =>
            row.BranchHead ? row.BranchHead.nrp : row.nrp || "",
        };
      }
    } else if (column === "branch") {
      if (
        [
          "sales",
          "branch-head",
          "tnt",
          "supervisor",
          "mobbi-supervisor",
        ].includes(role)
      ) {
        result = {
          key: "branch",
          title: "Branch",
          dataIndex: "branch",
          width: 200,
          render: (text, row) => this.getBranch(row, role),
        };
      }
    } else if (column === "supervisor") {
      if (["sales"].includes(role)) {
        result = {
          key: "supervisor",
          title: "Supervisor",
          dataIndex: "supervisor",
          width: 200,
          render: (text, row) =>
            row
              ? row.SalesProfile
                ? row.SalesProfile.Supervisor
                  ? row.SalesProfile.Supervisor.name
                  : null
                : null
              : null,
        };
      }
    } else if (column === "area") {
      if (role === "boh") {
        result = {
          key: "area",
          title: "Area",
          dataIndex: "area",
          width: 200,
          render: (text, row) =>
            row
              ? row.BOHProfile
                ? row.BOHProfile.AreaBranch
                  ? row.BOHProfile.AreaBranch.name
                  : null
                : null
              : null,
        };
      } else if (role === "abm") {
        result = {
          key: "area",
          title: "Area",
          dataIndex: "area",
          width: 200,
          render: (text, row) =>
            row
              ? row.Director
                ? row.Director.AreaBusiness
                  ? row.Director.AreaBusiness.area
                  : null
                : null
              : null,
        };
      }
    } else if (column === "tnt") {
      result = {
        key: "tntUsers",
        title: "TNT",
        dataIndex: "tntUsers",
        width: 200,
        render: (text, row) => this.getTNT(row),
      };
    } else if (column === "is-disable-appraisal") {
      if (role === "appraiser") {
        result = {
          key: "isDisableAppraisal",
          title: "On / Off Appraisal",
          dataIndex: "isDisableAppraisal",
          width: 200,
          render: (text, row) =>
            row.Appraiser && (
              <Switch
                checked={!row.Appraiser.isDisableAppraisal}
                onChange={() =>
                  this.updateDisableAppraisal(
                    row.id,
                    !row.Appraiser.isDisableAppraisal
                  )
                }
              />
            ),
        };
      }
    }

    return result;
  }

  openModalUpload(val) {
    this.setState({ openModalUpload: val });
  }

  addFileList(file) {
    this.setState({ fileList: file, disableButton: file ? false : true });
  }

  async uploadData() {
    const { fileList } = this.state;
    if (fileList) {
      const role = this.props.match.params.role;
      this.setState({ confirmLoading: true });
      let formData = new FormData();
      formData.append("file", fileList);
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/admin-panel/user/upload/${role}`,
        formData
      )
        .then((res) => {
          message.success(`Berhasil Update User ${role}`);
          this.setState({
            confirmLoading: false,
            openModalUpload: false,
            isLoading: true,
            fileList: null,
            disableButton: true,
          });
          this.fetchUser();
        })
        .catch((err) => {
          errorMessage(err.response || err);
          this.setState({ confirmLoading: false });
        });
    } else {
      message.error("Silahkan pilih file CSV terlebih dahulu");
    }
  }

  visibleModalDownload(val) {
    this.setState({ openModalDownload: val });
  }

  updateDisableAppraisal(id, isDisableAppraisal) {
    // if (!query) query = "";
    this.setState({ isLoading: false });
    axios
      .put(`/admin-panel/disable-appraisal/appraiser/${id}`, {
        isDisableAppraisal,
      })
      .then((result) => {
        this.setState({
          isLoading: true,
        });
        this.fetchUser();
      })
      .catch((err) => {
        message.error("Gagal update appraiser app status");
        this.setState({ isLoading: false });
      });
  }

  render() {
    const role = this.getRoleUser();
    const objRoleNrp = this.getObjRole("nrp");
    const objRoleBranch = this.getObjRole("branch");
    const objSupervisor = this.getObjRole("supervisor");
    const objArea = this.getObjRole("area");
    const objIsDisableAppraisal = this.getObjRole("is-disable-appraisal");

    const columns = [
      {
        key: "id",
        title: "ID",
        dataIndex: "id",
        width: 70,
        render: (text, record) => {
          record = record.User ? record.User : record;
          return <div>{record.id}</div>;
        },
      },
      {
        key: "email",
        title: "Email",
        dataIndex: "email",
        width: 400,
        render: (text, record) => {
          record = record.User ? record.User : record;
          return <div>{record.email}</div>;
        },
        ...this.getColumnSearchProps("email"),
      },
      {
        key: "name",
        title: "Name",
        dataIndex: "name",
        width: 300,
        render: (text, record) => {
          return <div>{record.name}</div>;
        },
        ...this.getColumnSearchProps("name"),
      },
      {
        key: "role",
        title: "Role",
        dataIndex: "role",
        render: (text, record) => {
          record = record.User ? record.User : record;
          return <div>{record.role}</div>;
        },
        width: 200,
      },
      {
        key: "status",
        title: "Status",
        width: 200,
        // dataIndex: "status",
        render: (text, record) => {
          record = record.User ? record.User : record;
          return (
            <div>
              {record.status === "ACTIVE" ? (
                <Tag color="green">{record.status}</Tag>
              ) : (
                <Tag color="red">{record.status}</Tag>
              )}
            </div>
          );
        },
      },
      {
        title: "Action",
        key: "action",
        width: 200,
        render: (text, record) => {
          record = record.User ? record.User : record;
          return (
            <div>
              {record.role !== "SUPER_ADMIN" && (
                <React.Fragment>
                  <Tooltip placement="bottom" title="Edit User">
                    <Button
                      type="primary"
                      icon="edit"
                      onClick={() =>
                        this.props.history.push({
                          pathname: `/home/user/${record.id}/update`,
                          query: {
                            role: this.props.match.params.role,
                            user: this.getRoleUser(),
                            tabUser: this.tabUser(record.role),
                          },
                        })
                      }
                    />
                  </Tooltip>{" "}
                  {record.status === "ACTIVE" && (
                    <Tooltip placement="bottom" title="Delete User">
                      <Button
                        type="danger"
                        icon="delete"
                        onClick={() => this.deleteUser(record.id, record.email)}
                      />
                    </Tooltip>
                  )}
                  {record.status !== "ACTIVE" && (
                    <Tooltip placement="bottom" title="Activate User">
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#2ECC71",
                          borderColor: "#2ECC71",
                        }}
                        icon="check"
                        onClick={() => this.activateUser(record)}
                      />
                    </Tooltip>
                  )}
                </React.Fragment>
              )}
            </div>
          );
        },
      },
    ];

    if (objRoleNrp) columns.splice(1, 0, objRoleNrp);
    if (objRoleBranch) {
      if (
        ["Branch Head", "Salesman", "Supervisor", "Mobbi Supervisor"].includes(
          role
        )
      ) {
        columns.splice(4, 0, objRoleBranch);
        if (role === "Salesman") {
          columns.splice(5, 0, objSupervisor);
        }
      } else if (role === "TNT") {
        columns.splice(3, 0, objRoleBranch);
      }
    }
    if (objArea) columns.splice(3, 0, objArea);
    if (objIsDisableAppraisal) columns.splice(3, 0, objIsDisableAppraisal);

    return (
      <Card title={`User List - ${role}`}>
        <div style={{ marginBottom: 10 }}>
          <Link
            to={{
              pathname: `/home/user/create`,
              query: {
                role: this.props.match.params.role,
                user: this.getRoleUser(),
              },
            }}>
            <Button style={{ marginRight: 8 }}>Create User</Button>
          </Link>
          {role && !["all", "Mobbi Supervisor", "Other"].includes(role) && (
            <div style={{ float: "right" }}>
              {["Salesman", "Branch Head", "Supervisor", "TNT"].includes(
                role
              ) && (
                <Button
                  onClick={() => this.downloadBranch()}
                  style={{ marginRight: 8 }}>
                  Download Cabang
                </Button>
              )}

              {["BOH"].includes(role) && (
                <Button
                  onClick={() => this.downloadArea()}
                  style={{ marginRight: 8 }}>
                  Download Area
                </Button>
              )}
              <Button
                onClick={() => this.visibleModalDownload(true)}
                style={{ marginRight: 8 }}>
                Download Data
              </Button>
              {!["ABM"].includes(role) && (
                <Button onClick={() => this.openModalUpload(true)}>
                  Upload Data
                </Button>
              )}
            </div>
          )}
        </div>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <Table
            pagination={{
              pageSize: this.state.limit ? this.state.limit.toString() : "100",
              // current: this.state.page || 1,
              total: this.state.count ? this.state.count.toString() : "100",
            }}
            columns={columns}
            // size="small"
            rowKey="id"
            dataSource={this.state.userList}
            scroll={{ y: 400, x: 1200 }}
            tableLayout="-"
            bordered
            onChange={(pagination, filters, sorter) =>
              this.handleTableChange(pagination, filters, sorter)
            }
          />
        </Spin>

        <Modal
          visible={this.state.openModalUpload}
          title={`Upload User - ${role}`}
          onOk={() => this.uploadData()}
          onCancel={() => this.openModalUpload(false)}
          confirmLoading={this.state.confirmLoading}
          okButtonProps={{ disabled: this.state.disableButton }}>
          <ModalUpload fileList={this.addFileList} />
        </Modal>

        <ModalDownload
          visible={this.state.openModalDownload}
          isLoading={this.state.confirmLoading}
          role={this.props.match.params.role}
          downloadData={this.downloadData}
          onChangeFilter={this.onChangeFilter}
          visibleModal={this.visibleModalDownload}
          branch={this.state.branch}
        />
      </Card>
    );
  }
}
let mapStateToProps = ({ Auth }) => ({ Auth });
export default connect(mapStateToProps)(UserList);



// WEBPACK FOOTER //
// src/components/Dashboard/User/UserList.js